import { Component, OnInit } from '@angular/core';
import { IaudienceDesignerUrlDto } from '../../models/IAudienceDesignerUrlDTO';
import { Utils } from '../../Utils';
import { FezaDataService } from '../../services/fezadata.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../services/auth-service.service';
import { IRelatedBid } from '../../models/IRelatedBid';
import { Router } from '@angular/router';
@Component({
  selector: 'quote-search',
  templateUrl: './quote-search.component.html',
  styleUrls: ['./quote-search.component.css']
})
export class QuoteSearchComponent implements OnInit {
  externalQuoteNumber: string;
  relatedBids: IRelatedBid[];
  found: boolean;

  constructor(private spinner: NgxSpinnerService,
    private fezaService: FezaDataService,
    private router: Router) { }

  ngOnInit() {
    this.found = true; //hide error until they search
    this.relatedBids = [];
  }

  onResponse(bidId: string) {
    this.router.navigate(['/response'], { queryParams: { bidId: bidId } });
  }

  onRequest(bidId: string) {
    this.router.navigate(['/request'], { queryParams: { bidId: bidId } });
  }

  getBidIds() {
    this.fezaService.GetRelatedBids(this.externalQuoteNumber).subscribe(relatedBids => {
      this.relatedBids = relatedBids;
      this.found = relatedBids.length > 0;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/quote-search/quote-search.component.ts